setTimeout(function () {
  try {
    var document_url = document.URL;

    var sa_params =
      'sa_params=true&utm_source=stackadapt&utm_medium=display&utm_campaign=dynamicRT';
    var sa_click =
      document_url.indexOf('?') > 0
        ? document_url + '&' + sa_params
        : document_url + '?' + sa_params;
    if (!sa_click) {
      return;
    }

    // snippets/drt-pixel.liquid renders the product data; reading it avoids depending on page layout.
    var sa_data = JSON.parse(
      document.getElementById('drt-pixel-data').textContent,
    );

    var sa_image = sa_data.image;
    if (!sa_image) {
      return;
    }

    var sa_name = sa_data.title;
    if (!sa_name) {
      return;
    }

    var sa_price = sa_data.price;
    if (!sa_price) {
      return;
    }

    !(function (s, a, e, v, n, t, z) {
      if (s.saq) return;
      n = s.saq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!s._saq) s._saq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '1.0';
      n.queue = [];
      t = a.createElement(e);
      t.async = !0;
      t.src = v;
      z = a.getElementsByTagName(e)[0];
      z.parentNode.insertBefore(t, z);
    })(window, document, 'script', 'https://tags.srv.stackadapt.com/events.js');
    saq('drt', 'Z1ECsi6Ne6Yo7MD1W22jqW', {
      '${drt_title}': encodeURIComponent(sa_name),
      '${drt_image}': encodeURIComponent(sa_image),
      '${drt_price}': encodeURIComponent(sa_price),
      '${drt_click}': encodeURIComponent(sa_click),
    });
  } catch (e) {
    if (isDev) console.error('StackAdapt pixel skipped:', e);
  }
}, 4000);
